<div class="virtual-scroll-data-source" *ngIf="hasSections">
    <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="5" class="viewport">
        <div>
            <div class="header">
                <div class="calibration-field-header">
                    <div *ngIf="showRequiredFieldsSwitch" class="required-fields-only-switch-container">
                        <mat-slide-toggle [(ngModel)]="viewSettingsService.showOnlyRequiredFields">Required Fields
                            Only</mat-slide-toggle>
                    </div>
                </div>
                <div class="header-cell" *ngFor="let calibrationData of calibrations">
                    <div class="actions-row">
                        <cut-down-content length="14"
                            [ngClass]="{'red-text': calibrationData?.calibrationSet?.importValidationResult && !calibrationData?.calibrationSet?.importValidationResult.isValid}">{{calibrationData.calibrationSet.Name}}</cut-down-content>
                        <calibration-set-attributes *ngIf="!hideAttributeButtons"
                            [identifiers]="calibrationData.calibrationSet.identifier"
                            [attributePopupTitleDetails]="calibrationData.calibrationSet.Name">
                        </calibration-set-attributes>
                    </div>
                    <div class="icons-container to-right">
                        <ziq-calibration-set-attributes-icons *ngIf="!hideAttributeButtons"
                            [attributesFlags]="calibrationData.calibrationSet">
                        </ziq-calibration-set-attributes-icons>
                        <!-- In case when attributes icons are hidden, we still want to show Is not calibrated icon for zone combinations,
                         so we add it separately here with condition to only show when attributes icons are hidden -->
                        <ziq-entity-attribute-icon *ngIf="hideAttributeButtons && calibrationData.calibrationSet.isZoneCombination && calibrationData.calibrationSet.IsNotCalibrated" [hint]="'Is not calibrated'"
                            [isActive]="calibrationData.calibrationSet.IsNotCalibrated" [activeIcon]="'block'">
                        </ziq-entity-attribute-icon>
                    </div>
                </div>
            </div>
            <accordion [allowMultipleOpenedSections]="true">
                <accordion-group *ngFor="let section of sections; index as i" [title]="section.label"
                    [active]="!!(i===0)" [templateRef]="sectionTemplate">
                    <ng-template #sectionTemplate>
                        <div *ngFor="let field of getSectionFields(section)" class="calibration-values-row">
                            <ziq-header-field
                                [ngClass]="{'red-text': fieldHasValidationIssues(field), 'calibration-field-header': true}"
                                [fieldSettings]="field" [currentTab]="currentTab" [tableType]="table.calibrationType"
                                [table]="table" [hideAttributeButtons]="hideAttributeButtons" [readOnly]="readOnly">
                            </ziq-header-field>
                            <div class="value-cell"
                                *ngFor="let calibrationData of calibrations; trackBy: getCellIdentifier.bind(this, i)">
                                <ziq-number-value-field *ngIf="field.type == fieldType.NUMBER" [currentTab]="currentTab"
                                    [model]="calibrationData" [fieldSettings]="field" [readOnly]="readOnly"
                                    [hideAttributeButtons]="hideAttributeButtons"
                                    [attributePopupTitleDetails]="calibrationData.calibrationSet.Name + ' - ' + field.label"></ziq-number-value-field>
                                <ziq-boolean-value-field *ngIf="field.type == fieldType.BOOLEAN"
                                    [currentTab]="currentTab" [model]="calibrationData" [fieldSettings]="field"
                                    [readOnly]="readOnly" [hideAttributeButtons]="hideAttributeButtons"
                                    [attributePopupTitleDetails]="calibrationData.calibrationSet.Name + ' - ' + field.label"></ziq-boolean-value-field>
                                <ziq-number-na-value-field *ngIf="field.type == fieldType.NUMBER_NA"
                                    [currentTab]="currentTab" [model]="calibrationData" [fieldSettings]="field"
                                    [table]="table" [readOnly]="readOnly" [hideAttributeButtons]="hideAttributeButtons"
                                    [attributePopupTitleDetails]="calibrationData.calibrationSet.Name + ' - ' + field.label"></ziq-number-na-value-field>
                            </div>
                        </div>
                    </ng-template>
                </accordion-group>
            </accordion>
        </div>
    </cdk-virtual-scroll-viewport>
</div>
